<template>
    <div id="supplier-verification">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click="$router.push('/score')" style="cursor: pointer">Riesgo Crediticio</li>
                <li class="breadcrumb-item active" aria-current="page">Verificación de proveedores</li>
            </ol>
        </nav>

        <div class="container-fluid">
            <div class="vx-row">
                <div class="vx-col w-full mb-4">
                    <vx-card>
                        <h1 class="bold big-title m-0">Verificación de <span>Proveedores</span>.</h1>
                    </vx-card>
                </div>

                <div class="vx-col w-full mb-4">
                    <vx-card>
                        <div class="vx-row">
                            <div class="vx-col w-11/12">
                                <input type="text" placeholder="Buscar proveedor..." class="form-control" v-model="search"
                                    v-on:keyup.enter="searchSuppliersNotVerified()">
                                <small>Criterios de busqueda: SID,  Nombre Comercial</small>
                            </div>
                            <div class="vx-col w-1/12">
                                <vs-button color="warning" type="filled" icon="search"
                                    @click="searchSuppliersNotVerified()"></vs-button>
                            </div>
                        </div>
                    </vx-card>
                </div>

                <div class="vx-col w-full">
                    <vx-card>
                        <vs-table stripe max-items="15" pagination search :data="suppliers" noDataText="No hay datos disponibles">
                            <template slot="thead">
                                <vs-th class="bold" v-for="(col, idx) in columns" v-bind:key="idx"
                                    :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                            </template>
                            <template slot="header">
                                <h4>Lista de proveedores</h4>
                            </template>
                            <template v-if="isMounted" slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].sid">
                                        <router-link :to="`/suppliers/${tr.id}`" target='_blank'>
                                            {{ tr.user_id }} | {{ tr.id }}
                                        </router-link>
                                    </vs-td>
                                    <vs-td>
                                        {{ tr.tradename }}
                                    </vs-td>
                                    <vs-td>
                                        {{ getFiscalName(tr) }}
                                    </vs-td>
                                    <vs-td>
                                        {{ getFiscalRFC(tr) || "--" }}
                                    </vs-td>
                                    <vs-td>
                                        {{ sessionFormat(tr.created_at) }}
                                    </vs-td>
                                    <vs-td>
                                        {{ sessionFormat(tr.verification_request_date) || "--" }}
                                    </vs-td>
                                    <vs-td>
                                        <vs-chip transparent color="success">
                                            {{ getLegalProfileStatus(tr) }}
                                        </vs-chip>
                                    </vs-td>
                                    <vs-td>
                                        <vs-switch @click.stop="saveLegalProfile(tr.id,!switchValue[tr.id])" v-model="switchValue[tr.id]"/>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vx-card>
                </div>
            </div>
            <vx-card></vx-card>
        </div>
    </div>
</template>

<script>
import dateHelper from '@mixins/dateHelper.js';
const columns = [
    { title: "UID | SID", key: "sid", sortable: true }
    , { title: "NOMBRE COMERCIAL", key: "tradename", sortable: true }
    , { title: "NOMBRE / RAZÓN SOCIAL", key: "name", sortable: true }
    , { title: "RFC", key: "fiscal", sortable: true }
    , { title: "F. REGISTRO", key: "email", sortable: false }
    , { title: "F. SOLICITUD DE VERIFICACIÓN", key: "phone", sortable: false }
    , { title: "PERFIL LEGAL", key: "phone", sortable: false }
    , { title: "ACCIONES", key: "state", sortable: true }
]
export default {
    name: "SupplierVerification",
    mixins: [dateHelper],
    data: () => ({
        columns: columns,
        suppliers: null,
        isMounted: false,
        search: null,
        status: 3,
        switchValue: []
    }),
    async mounted(){
        await this.getSuppliersNotVerified();
        this.isMounted = true;
    },
    methods: {
        getSuppliersNotVerified() {
            this.showLoading(true);
            axios.post('/api/suppliers/notVerified', {
                status: this.status,
            })
                .then(response => {
                    this.showLoading(false);
                    this.suppliers = response.data.suppliers;
                    this.setSwitchValues();
                }).catch(error => {
                    this.showLoading(false);
                    this.errorNotif(error.response.data.message, error.response.data.errors);
                });
        },
        searchSuppliersNotVerified() {
            this.showLoading(true);
            axios.post('/api/suppliers/notVerified/search', {
                status: this.status,
                search: this.search,
            })
                .then(response => {
                    this.showLoading(false);
                    this.suppliers = response.data.suppliers;
                    this.setSwitchValues();
                }).catch(error => {
                    this.showLoading(false);
                    this.errorNotif(error.response.data.message, error.response.data.errors);
                });
        },
        getFiscalName(supplier) {
            const user = supplier.user;
            if(user.person_type == 0) {
                return user.business.name;
            } else {
                return `${user.personal.first_name} ${user.personal.second_name} ${user.personal.last_name_1} ${user.personal.last_name_2} `
            }
        },
        getFiscalRFC(supplier) {
            const user = supplier.user;
            if(user.person_type == 0) {
                return user.business.rfc;
            } else {
                return user.personal.rfc;
            }
        },
        getLegalProfile(supplier) {
            const user = supplier.user;
            const fiscal = user.person_type == 0 ? user.business : user.personal;

            return fiscal.legal_profile;
        },
        getLegalProfileStatus(supplier) {
            const result = this.getLegalProfile(supplier);
            let message = "Perfil legal revisado.";
            if(result == null) {
                message = "No se ha realizado la revisión de perfil legal."
            } else if(result.has_legal_claims == 1) {
                message = "El Proveedor tiene coincidencias relevantes en material legal."
            }

            if(result != null && result.updated_at != null) {
                message += ` ${this.sessionFormat(result.updated_at)}`
            }
            
            return message;
        },
        setSwitchValues() {
            this.suppliers.forEach(supplier => {
                const legalProfile = this.getLegalProfile(supplier);
                if(legalProfile != null && legalProfile.has_legal_claims == 1) {
                    this.switchValue[supplier.id] = true;
                } else {
                    this.switchValue[supplier.id] = false;
                }
            });
        },
        async saveLegalProfile(supplierId, value) {
            try {
                this.showLoading(true);
                const res = await axios.post(`/api/supplier-onboarding/post/legal-profile`, {
                    supplier_id: supplierId,
                    hasLegalIssues: value
                });
                await this.getSuppliersNotVerified();
                this.showLoading(false);
                this.saveSuccessNotif();
            } catch (error) {
                this.showLoading(false);
                console.error(error);
                this.failedOperationNotif();
            }
        }
    }
}
</script>